export default __webpack_public_path__ + "static/media/IconsWaiting_Room_Channel.111791d8.svg";